// import { doctor, pharmacy } from '@/configs/translates.config';
import translates from '@/configs/translates.config';

export default {
	save: {
		en: 'Save',
		ar: 'حفظ'
	},
	add: {
		en: 'Add',
		ar: 'إضافة'
	},
	edit: {
		en: 'Edit',
		ar: 'تعديل'
	},
	delete: {
		en: 'Delete',
		ar: 'حذف'
	},
	done: {
		en: 'Done',
		ar: 'موافق'
	},
	close: {
		en: 'Close',
		ar: 'إغلاق'
	},
	send: {
		en: 'Send',
		ar: 'إرسال'
	},
	cancel: {
		en: 'Cancel',
		ar: 'إلغاء'
	},
	update: {
		en: 'Update',
		ar: 'تحديث'
	},
	ok: {
		en: 'OK',
		ar: 'موافق'
	},
	connected: {
		en: 'Connected',
		ar: 'متصل'
	},
	disconnected: {
		en: 'Disconnected',
		ar: 'غير متصل'
	},
	'internet-quality': {
		en: 'Internet quality',
		ar: 'جودة الإنترنت'
	},
	'internet-quality-detail-connected': {
		en: 'Connected - {quality} ({latency} ms)',
		ar: 'متصل - {quality} ({latency} مللي ثانية)'
	},
	'internet-quality-detail-disconnected': {
		en: 'Disconnected',
		ar: 'غير متصل'
	},
	'internet-quality-levels': {
		en: {
			excellent: 'excellent',
			good: 'good',
			weak: 'weak',
		},
		ar: {
			excellent: 'ممتاز',
			good: 'جيد',
			weak: 'ضعيف',
		}
	},
	filters: {
		en: 'Filters',
		ar: 'الفلاتر'
	},
	inputs: {
		en: {
			username: 'Username',
			password: 'Password',
			date: 'Date',
			region: 'Region',
			'customer-name': 'Customer name',
			persons: 'Persons',
			name: 'Name',
			samples: 'Items',
			sample: 'Item',
			amount: 'Amount',
			'unavailable-products': 'Unavailable Products',
			competitors: 'Competitors',
			competitor: 'Competitor',
			'core-message': 'Core message',
			duration: 'Duration',
			'duration-minutes': 'Duration (in minutes)',
			minutes: 'minutes',
			'other-materials': 'Other Materials',
			'visit-notes': 'Visit notes',
			objection: 'Objection',
			'next-call': 'Next Call',
			notes: 'Notes',
			'delivery-date': 'Delivery date',
			'center-notes': 'Center notes',
			report: 'Report',
			specialty: translates.specialty.en,
			workload: 'Workload',
			address: 'Address',
			'contact-type': 'Contact Type',
			contact: 'Contact',
			reason: 'Reason',
			'product-form': 'Product form',
			'product-name': 'Product name',
			'pharmaceutical-form': 'Form',
			dose: 'Dose',
			'pieces-count': 'Pieces count',
			material: 'Material',
			type: 'Type',
			'days-count': 'Days count',
			'start-date': 'Start date',
			'pricing-types': 'Pricing types',
			price: 'Price',
			discount: 'Discount',
			free: 'Free',
			'payment-type': 'Payment type',
			'paid-amount': 'Paid amount',
			weekend: 'Weekend',
			'work-hours-from': 'Work hours from',
			'work-hours-to': 'Work hours to',
			'best-time-to-visit': 'Best time to visit',
			'resident-doctors': translates.residentDoctors.en,
			'doctor-hobbies': translates.doctorHobbies.en,
			'personal-note': 'Personal note',
			'pharmacy-info': translates.pharmacyInfo.en,
			loyalty: 'Loyalty',
			religion: 'Religion',
			personality: 'Personality',
			birthdate: 'Birthdate',
			quantity: 'Quantity',
			'nearby-pharmacy-1': translates.nearbyPharmacy1.en,
			'nearby-pharmacy-2': translates.nearbyPharmacy2.en,
			'works-in-centers': 'Works in centers',
			'pharmacist-info': translates.pharmacistInfo.en,
			'customer-type': 'Customer type',
		},
		ar: {
			username: 'اسم المستخدم',
			password: 'كلمة المرور',
			date: 'التاريخ',
			region: 'المنطقة',
			'customer-name': 'اسم العميل',
			persons: 'الأشخاص',
			name: 'الاسم',
			samples: 'المواد',
			sample: 'مادة',
			amount: 'الكمية',
			'unavailable-products': 'المنتجات غير متوفرة',
			competitors: 'المنافسون',
			competitor: 'منافس',
			'core-message': 'الرسالة الأساسية',
			duration: 'المدة',
			'duration-minutes': 'المدة (بالدقائق)',
			minutes: 'دقائق',
			'other-materials': 'مواد أخرى',
			'visit-notes': 'ملاحظات الزيارة',
			objection: 'اعتراض',
			'next-call': 'التواصل القادم',
			notes: 'الملاحظات',
			'delivery-date': 'موعد التسليم',
			'center-notes': 'ملاحظات المركز',
			report: 'التقرير',
			specialty: translates.specialty.ar,
			workload: 'الفئة',
			address: 'العنوان',
			'contact-type': 'التوع',
			contact: 'تواصل',
			reason: 'السبب',
			'product-form': 'شكل المنتج',
			'product-name': 'اسم المنتح',
			'pharmaceutical-form': 'الشكل',
			dose: 'الجرعة',
			'pieces-count': 'عدد القطع',
			material: 'المادة',
			type: 'النوع',
			'days-count': 'عدد الأيام',
			'start-date': 'تاريخ البدء',
			'pricing-types': 'نمط التسعير',
			price: 'السعر',
			discount: 'الحسم',
			free: 'مجاني',
			'payment-type': 'طريقة الدفع',
			'paid-amount': 'المبلغ المدفوع',
			weekend: 'عطلة نهاية الأسبوع',
			'work-hours-from': 'ساعات العمل من',
			'work-hours-to': 'ساعات العمل إلى',
			'best-time-to-visit': 'أفضل وقت للزيارة',
			'resident-doctors': translates.residentDoctors.ar,
			'doctor-hobbies': translates.doctorHobbies.ar,
			'personal-note': 'ملاحظة شخصية',
			'pharmacy-info': translates.pharmacyInfo.ar,
			loyalty: 'الولاء',
			religion: 'الديانة',
			personality: 'الشخصية',
			birthdate: 'عيد الميلاد',
			quantity: 'الكمية',
			'nearby-pharmacy-1': translates.nearbyPharmacy1.ar,
			'nearby-pharmacy-2': translates.nearbyPharmacy2.ar,
			'works-in-centers': 'يعمل في مراكز',
			'pharmacist-info': translates.pharmacistInfo.ar,
			'customer-type': 'نوع العميل',
		}
	},
	headers: {
		en: {
			customer: 'customer'
		},
		ar: {
			customer: 'العميل'
		}
	},

	'payment-method': {
		en: {
			cash: 'Cash',
			credit: 'Credit',
			debit: 'Debit',
		},
		ar: {
			cash: 'نقدي',
			credit: 'بطاقة',
			debit: 'دَين',
		}
	},
	components: {
		en: {
			today: 'Today',
			logout: 'Logout'
		},
		ar: {
			today: 'اليوم',
			logout: 'تسجيل خروج'
		}
	},

	messages: {
		en: {
			'are-you-sure-you-want-to-delete-$': "Are you sure you want to <span class='red--text'>DELETE</span> {text}?",
			'one-address-for-pharmacies-and-centers': 'Sorry, but one address is allowed for pharmacies and centers',
			'matched-entities': 'Matched entities',
			'confirm-delete': 'Confirm delete'
		},
		ar: {
			'are-you-sure-you-want-to-delete-$': "هل أنت متأكد من <span class='red--text'>حذف</span> {text}؟",
			'one-address-for-pharmacies-and-centers': 'عذراً ، لكن يسمح بعنوان واحد للصيدليات والمراكز',
			'matched-entities': 'جهات مطابقة',
			'confirm-delete': 'تأكيد الحذف',
		}
	},

	'validation-messages': {
		en: {
			required: 'This field is required',
			number: 'This number should be non-negative.',
			url: 'Invalid URL.',
			val: 'Invalid date. Date format is \'yyyy-mm-dd\'.',
			password: 'password should be 4 characters at least',
			email: 'Invalid e-mail.',
			'one-address-at-least': 'Must add one address at least',
		},
		ar: {
			required: 'هذا الحقل مطلوب',
			number: 'يجب أن يكون رقمًا غير سالبًا.',
			url: 'URL غير صالح.',
			val: 'تاريخ غير صالح. تنسيق التاريخ هو \'yyyy-mm-dd\'.',
			password: 'يجب أن تكون كلمة المرور 4 أحرف على الأقل.',
			email: 'بريد إلكتروني غير صالح.',
			'one-address-at-least': 'يجب إضافة عنوان واحد على الأقل',
		}
	},
	'no-internet-connection': {
		en: 'No internet connection',
		ar: 'لا يوجد اتصال بالإنترنت'
	},
	'internet-connection-restored': {
		en: 'Internet connection restored',
		ar: 'تم استعادة الاتصال بالإنترنت'
	},
	'invoice-preview': {
		en: {
			title: 'Invoice Preview',
			share: 'Share',
			print: 'Print',
			download: 'Download',
			'share-whatsapp': 'Share via WhatsApp',
			'share-email': 'Share via Email',
			'missing-visit-id': 'Missing visit id',
			'failed-load': 'Failed to load invoice PDF',
			'error-unauthorized': 'Unauthorized to access this invoice (401)',
			'error-not-found': 'Invoice not found (404)',
			'error-server': 'Server error. Please try again later (5xx)',
			'error-network': 'Network connection error. Please check your internet connection.',
			'share-not-supported': 'Sharing is not supported on this device',
			'share-failed': 'Failed to share invoice',
			'share-message': 'Please find attached the invoice',
			'whatsapp-attachment-note': 'WhatsApp opened. If file share is unavailable, attach the downloaded invoice manually.',
			'email-attachment-note': 'Email composer opened. Please attach the downloaded invoice manually.',
			retry: 'Retry',
			'visit-id': 'Visit ID',
		},
		ar: {
			title: 'معاينة الفاتورة',
			share: 'مشاركة',
			print: 'طباعة',
			download: 'تنزيل',
			'share-whatsapp': 'مشاركة عبر واتساب',
			'share-email': 'مشاركة عبر البريد الإلكتروني',
			'missing-visit-id': 'معرف الزيارة غير موجود',
			'failed-load': 'فشل تحميل ملف الفاتورة',
			'error-unauthorized': 'غير مصرح للوصول إلى هذه الفاتورة (401)',
			'error-not-found': 'الفاتورة غير موجودة (404)',
			'error-server': 'خطأ في الخادم. يرجى المحاولة لاحقاً (5xx)',
			'error-network': 'خطأ في الاتصال بالإنترنت. يرجى التحقق من اتصالك.',
			'share-not-supported': 'المشاركة غير مدعومة على هذا الجهاز',
			'share-failed': 'فشلت مشاركة الفاتورة',
			'share-message': 'يرجى الاطلاع على الفاتورة المرفقة',
			'whatsapp-attachment-note': 'تم فتح واتساب. إذا لم تتوفر مشاركة الملف، أرفق الفاتورة التي تم تنزيلها يدوياً.',
			'email-attachment-note': 'تم فتح البريد الإلكتروني. يرجى إرفاق الفاتورة التي تم تنزيلها يدوياً.',
			retry: 'إعادة المحاولة',
			'visit-id': 'معرف الزيارة',
		}
	},

	'current-balance': {
		en: 'Current balance',
		ar: 'الرصيد الحالي'
	}

}